// extracted by mini-css-extract-plugin
export default {"container":"eS-z","topReviewHeading":"fS-z","criticalReview":"gS-z","favorableReview":"hS-z","vsSeparator":"iS-z"};